export default __webpack_public_path__ + "static/media/application1.7d66cf49.svg";